/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MachineType,
} from '../models/index';
import {
    MachineTypeFromJSON,
    MachineTypeToJSON,
} from '../models/index';

export interface CreateMachineTypeRequest {
    machineType: MachineType;
}

export interface DeleteMachineTypeRequest {
    id: string;
}

export interface GetMachineTypeRequest {
    id: string;
}

export interface UpdateMachineTypeRequest {
    id: string;
    machineType: MachineType;
}

/**
 * 
 */
export class MachineTypeControllerApi extends runtime.BaseAPI {

    /**
     */
    async createMachineTypeRaw(requestParameters: CreateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        if (requestParameters['machineType'] == null) {
            throw new runtime.RequiredError(
                'machineType',
                'Required parameter "machineType" was null or undefined when calling createMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machine-types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineTypeToJSON(requestParameters['machineType']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async createMachineType(requestParameters: CreateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.createMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMachineTypeRaw(requestParameters: DeleteMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachineType(requestParameters: DeleteMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineTypeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllMachineTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineTypeFromJSON));
    }

    /**
     */
    async getAllMachineTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineType>> {
        const response = await this.getAllMachineTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMachineTypeRaw(requestParameters: GetMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async getMachineType(requestParameters: GetMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.getMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMachineTypeRaw(requestParameters: UpdateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachineType().'
            );
        }

        if (requestParameters['machineType'] == null) {
            throw new runtime.RequiredError(
                'machineType',
                'Required parameter "machineType" was null or undefined when calling updateMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machine-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineTypeToJSON(requestParameters['machineType']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async updateMachineType(requestParameters: UpdateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.updateMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
